/** Accept only local absolute paths, including after URL normalization. */
export function safeAuthRedirect(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return '/';
  // Reject control characters and backslashes, including encoded variants.
  let decoded;
  try { decoded = decodeURIComponent(value); } catch { return '/'; }
  if (/[\\\u0000-\u001f\u007f]/.test(decoded) || decoded.startsWith('//')) return '/';
  try {
    const url = new URL(value, 'https://redirect.invalid');
    if (url.origin !== 'https://redirect.invalid' || url.pathname.startsWith('//')) return '/';
    return url.pathname + url.search + url.hash;
  } catch { return '/'; }
}
